import { Link, useSearchParams } from "react-router-dom";
import { cn } from "@/lib/utils";
import { SubjectIcon } from "@/components/subject-icon";

type Student = {
  id: string;
  name: string;
};

type Subject = {
  id: string;
  name: string;
  icon: string;
};

type SessionsFiltersProps = {
  students: Student[];
  subjects: Subject[];
};

export function SessionsFilters({ students, subjects }: SessionsFiltersProps) {
  const [searchParams] = useSearchParams();

  const currentStudent = searchParams.get("student") || "";
  const currentSubject = searchParams.get("subject") || "";

  function buildUrl(key: string, value: string) {
    const params = new URLSearchParams(searchParams.toString());
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
    const queryString = params.toString();
    return `/sessions${queryString ? `?${queryString}` : ""}`;
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm text-muted-foreground">Mokinys:</span>
        <Link
          to={buildUrl("student", "")}
          className={cn(
            "px-3 py-1 text-sm rounded-full border transition-colors",
            !currentStudent
              ? "bg-primary text-primary-foreground border-primary"
              : "hover:bg-muted border-border"
          )}
        >
          Visi
        </Link>
        {students.map((student) => (
          <Link
            key={student.id}
            to={buildUrl("student", student.id)}
            className={cn(
              "px-3 py-1 text-sm rounded-full border transition-colors",
              currentStudent === student.id
                ? "bg-primary text-primary-foreground border-primary"
                : "hover:bg-muted border-border"
            )}
          >
            {student.name}
          </Link>
        ))}
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm text-muted-foreground">Dalykas:</span>
        <Link
          to={buildUrl("subject", "")}
          className={cn(
            "px-3 py-1 text-sm rounded-full border transition-colors",
            !currentSubject
              ? "bg-primary text-primary-foreground border-primary"
              : "hover:bg-muted border-border"
          )}
        >
          Visi
        </Link>
        {subjects.map((subject) => (
          <Link
            key={subject.id}
            to={buildUrl("subject", subject.id)}
            className={cn(
              "px-3 py-1 text-sm rounded-full border transition-colors inline-flex items-center gap-1.5",
              currentSubject === subject.id
                ? "bg-primary text-primary-foreground border-primary"
                : "hover:bg-muted border-border"
            )}
          >
            <SubjectIcon icon={subject.icon} className="h-3.5 w-3.5" />
            {subject.name}
          </Link>
        ))}
      </div>
    </div>
  );
}
